module.exports = __webpack_public_path__ + "static/media/dbz.b7dd013e.png";